define('views/lib/Podio.Views.SlotMachineCount',['require','underscore','jquery','lib/backbone/Backbone.PodioView','jst!slot_machine_count/_count','jst!slot_machine_count/_counter'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');

  var jstCount = require('jst!slot_machine_count/_count');
  var jstCounter = require('jst!slot_machine_count/_counter');

  return PodioView.extend({

    initialize : function(options) {

      _.bindAll(this, 'render', 'onRenderingFinished');

      this._super();

      this.elmContainer = this.options.elmContainer;
      this.count = this.options.count;
    },

    updateElementReference: function(elm) {
      this.elmContainer = elm;
    },

    getAnimationElement: function(newCount, count, state) {
      return this.getTemplateAsElement(jstCount, {
        content: count + '</br>' + newCount + '</br>' + count + '</br>',
        state: state
      });
    },

    renderStaticCount: function() {
      this.elmSlotMachine = $(this.getTemplate(jstCounter, {
        count: this.count
      }));

      this.elmContainer.empty();
      this.elmSlotMachine.appendTo(this.elmContainer);
    },

    onRenderingFinished: function(elmCount) {
      this.renderStaticCount();
    },

    render : function(newCount) {

      var hasChanged = newCount !== this.count;
      var isDecremented = newCount < this.count;

      this.renderStaticCount();

      if (hasChanged) { // Animation

        var elmAnimationCounter = this.getAnimationElement(newCount, this.count, 'animate');
        this.count = newCount;

        this.elmSlotMachine.empty();
        elmAnimationCounter.appendTo(this.elmSlotMachine);

        var lineHeight = elmAnimationCounter.height();
        var scrollTop = lineHeight * 1;

        if (isDecremented) {
          elmAnimationCounter.scrollTop(lineHeight * 2);
        }

        elmAnimationCounter.animate({
          scrollTop: scrollTop
        }, 400, this.onRenderingFinished.curry(elmAnimationCounter));

      }

      return this;
    }

  });

});

